import Modules from '@app/modules';
Modules.register({
    namespace: 'RF/CMS'
});
